import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const partnerCommissionApi = createAsyncThunk(
  "partnerCommission",
  async ({ month, year }) => {
    const params = {};
    if (month) {
      params.month = month;
    }
    if (year) {
      params.year = year;
    }
    // if (partner_username) {
    //   params.partner_username = partner_username?.toUpperCase();
    // }
    const response = await axiosInstance.get(`/partner_commisssion_report`, {
      params,
    });
    return response.data;
  }
);

const partnerCommissionSlice = createSlice({
  name: "partnerCommission",
  initialState: {
    partnerCommission: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnerCommissionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partnerCommissionApi.fulfilled, (state, action) => {
        state.partnerCommission = action.payload;
        state.loading = false;
      })
      .addCase(partnerCommissionApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default partnerCommissionSlice.reducer;
